import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { InputDialogComponent } from './input-dialog.component';
import { InputDialogData, InputDialogResult } from './input-dialog.types';

@Injectable({
  providedIn: 'root',
})
export class InputDialogService {
  constructor(private dialog: MatDialog) {}

  /**
   * Открывает модальное окно с полем ввода и кастомной конфигурацией
   */
  open(data: InputDialogData): Observable<InputDialogResult | undefined> {
    const dialogConfig: MatDialogConfig<InputDialogData> = {
      data: data,
      panelClass: 'input-dialog-pane',
      disableClose: false,
      autoFocus: true,
      restoreFocus: true,
    };

    const dialogRef = this.dialog.open(InputDialogComponent, dialogConfig);
    return dialogRef.afterClosed();
  }

  /**
   * Открывает простое окно с полем ввода
   */
  prompt(
    title: string,
    label: string,
    placeholder: string = '',
    initialValue: string = '',
    primaryButtonText: string = 'OK',
    secondaryButtonText: string = 'Cancel'
  ): Observable<InputDialogResult | undefined> {
    return this.open({
      title: title,
      label: label,
      placeholder: placeholder,
      initialValue: initialValue,
      primaryButton: { text: primaryButtonText },
      secondaryButton: { text: secondaryButtonText },
    });
  }
}



